import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { light: String, dark: String }

  connect() {
    this.boundUpdate = this.updateBorderColor.bind(this)
    this.pollInterval = null
    window.addEventListener("theme-toggle:changed", this.boundUpdate)
    this.waitForChart()
  }

  disconnect() {
    window.removeEventListener("theme-toggle:changed", this.boundUpdate)
    if (this.pollInterval) {
      clearInterval(this.pollInterval)
      this.pollInterval = null
    }
  }

  updateBorderColor() {
    const chartjs = this.findChartJs()
    if (!chartjs) return

    const theme = document.documentElement.getAttribute("data-bs-theme") || "light"
    const color = theme === "dark" ? this.darkValue : this.lightValue

    chartjs.data.datasets.forEach(ds => { ds.borderColor = color })
    chartjs.update("none")
  }

  waitForChart() {
    const MAX_POLL_ATTEMPTS = 30
    let attempts = 0
    this.pollInterval = setInterval(() => {
      if (this.findChartJs() || attempts > MAX_POLL_ATTEMPTS) {
        clearInterval(this.pollInterval)
        this.pollInterval = null
        this.updateBorderColor()
      }
      attempts++
    }, 150)
  }

  findChartJs() {
    if (!window.Chartkick) return null

    const divs = this.element.querySelectorAll("[id]")
    for (const div of divs) {
      const ckChart = Chartkick.charts[div.id]
      if (ckChart?.chart) return ckChart.chart
    }
    return null
  }
}
